import { render, staticRenderFns } from "./totalLoanReport.vue?vue&type=template&id=e6c7f346&"
import script from "./totalLoanReport.vue?vue&type=script&lang=js&"
export * from "./totalLoanReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports